// extracted by mini-css-extract-plugin
export var attachment = "_mi-a";
export var emailContainer = "_mi-4";
export var emailContentPaddedContainer = "_mi-b";
export var emailHeader = "_mi-6";
export var emailIframe = "_mi-3";
export var emailInfoIcon = "_mi-9";
export var emailShortenedSummary = "_mi-e";
export var infoDropdown = "_mi-0";
export var infoRowBoundedContent = "_mi-d";
export var internal = "_mi-5";
export var merchant = "_mi-8";
export var messageInputContainer = "_mi-h";
export var normal = "_mi-7";
export var replyCard = "_mi-f";
export var subtleButton = "_mi-1";
export var subtleButtonIconContainer = "_mi-2";
export var toggleViewRepliesButton = "_mi-c";
export var wrappingText = "_mi-g";